export class RegexHelper {
  static emailRegex: RegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static phoneRegex: RegExp = /^[0-9,+]+[0-9]*$/;

  static checkEmail = (email: string): boolean => {
    const regex = this.emailRegex;
    return regex.test(String(email).toLowerCase());
  };

  static checkPhone = (phone: string): boolean => {
    const regex = this.phoneRegex;
    return regex.test(String(phone));
  };
}
